import type { IVideoData } from '@unionco/alaris-app-types'

export const videoTestData = {
  src: '',
  runTime: 90, // as seconds
  title: 'Video Title'
} as IVideoData
